import { Component, OnInit, EventEmitter, ViewChild, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

import { GrantsSummaryService } from 'src/app/services/grants/grants-summary.service';
import { stateOptionsSample, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { UserService } from "src/app/services/user.service";
import { Subject } from 'rxjs';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { AppFunctionsService } from 'src/app/services/app-functions.service';
import { CommonService } from 'src/app/services/common.service';
import { ExtendedFormControlsComponent } from 'src/app/common/extended-form-controls/extended-form-controls.component';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DateObject, ScreenResponseModel } from 'src/app/models/common';

@Component({
  selector: 'app-grants-budget-allocate',
  templateUrl: './grants-budget-allocate.component.html',
  styleUrls: ['./grants-budget-allocate.component.scss']
})
export class GrantsBudgetAllocateComponent implements OnInit {

  @Input() public Content: any;
  appid: string = "";
  formFields;
  stateOptions = stateOptionsSample;
  totalfee: any;
  requestamount: any;
  budgetNotes:any;
  grantcurrencycode: any = "";
  granttype: number;
  allocateBudgetForm: UntypedFormGroup;
  content:any;
  heading:string;
  action: Subject<any> = new Subject();
  budgetTypeOptions = [];
  budgetSubTypeOptions = [];
  @ViewChild('extended') extendedForm: ExtendedFormControlsComponent;
  budgetType: any;
  budgetSubType: any;
  approvedDate: any;
  minDate : Date;

  maxDate: Date = new Date();
  disabledPresentDate = [
    new Date()
  ];

  IsAllocatedDateModified: boolean = false;  
  ALLOCATE_DATE: DateObject;
  CurrentDate: Date;
  staticformFields : any;
  StatusStr: any;
  ApplicationID: any;
  SCREEN_MODEL: any = null;
  ScreenName: string="";
  staticformFieldsLstest: any;
  
  constructor(
    private summaryService: GrantsSummaryService,
    public modalRef: NgbActiveModal,
    private appFunctions: AppFunctionsService,
    private modalService: NgbModal,
    public datepipe: DatePipe,
    private userService: UserService,
    private commonService: CommonService
    ) { 
      
    }

    getStaticFiledsData(screenCode: string) {
      this.commonService.getScreenStaticFields(screenCode,this.appid)
        .subscribe(summary => {
          this.staticformFields = summary["Data"]; 
          if(this.staticformFields.ALLOCATION_DATE.IS_PASTDATES_ALLOWED){
            this.minDate = new Date(); this.minDate.setHours(0,0,0,0);
          }
          else{
            this.minDate = null;
          }

        });
    }

    ngOnInit() {
      const grantapp = this.commonService.getGrantsApp();// "8b3a39fb-99ee-44ce-8c03-c5417eb040d2";
      this.appid = grantapp.ID;
      this.getStaticFiledsData('SCR-026');
      this.heading = this.Content.heading;
      this.granttype = grantapp.GRANT_TYPE;
      this.getFundCategoryList();

      // if (this.granttype == 1)
      //   this.grantcurrencycode = this.userService.getGrantCMECurrencySymbol();
      // else if (this.granttype == 2)
      //   this.grantcurrencycode = this.userService.getGrantSponsorCurrencySymbol();
      // else if (this.granttype == 3)
      //   this.grantcurrencycode = this.userService.getGrantCharitableCurrencySymbol();

      // if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
      //   this.grantcurrencycode = "$";

      this.allocateBudgetForm = new UntypedFormGroup({
        ID: new UntypedFormControl(null),
        APPLICATION_ID: new UntypedFormControl(null),
        BUGET_TYPE_ID: new UntypedFormControl("", [Validators.required]),
        BUDGET_SUB_TYPE_ID: new UntypedFormControl("", [Validators.required]),
        NOTES: new UntypedFormControl("", [Validators.required]),
        REQUESTED_AMOUNT: new UntypedFormControl("", [Validators.required]),
        TOTAL_FEE: new UntypedFormControl("", [Validators.required]),
        ALLOCATION_AMOUNT: new UntypedFormControl("", [Validators.required]),
        ALLOCATION_DATE: new UntypedFormControl("", [Validators.required]),
        ALLOCATION_DATEO: new UntypedFormControl("", [Validators.required]),
        ALLOCATION_NOTES: new UntypedFormControl("", [Validators.required])
      });

      this.allocateBudgetForm.controls["BUGET_TYPE_ID"].disable();
      this.allocateBudgetForm.controls["BUDGET_SUB_TYPE_ID"].disable();
      this.allocateBudgetForm.controls["NOTES"].disable();
      this.allocateBudgetForm.controls["REQUESTED_AMOUNT"].disable();
      this.allocateBudgetForm.controls["TOTAL_FEE"].disable();
      if (this.heading == "View") {
        this.GetEditData();
        this.allocateBudgetForm.disable();
      }
      if (this.heading == "Edit") {
        this.GetEditData();
       
      }
    }

  getFundCategoryList() {
    this.summaryService.getBudgetTypeList(this.appid).subscribe((result) => {
      if (result != null) {
        this.budgetTypeOptions = result;
        this.budgetTypeOptions = [{ label: "Select", value: null, checked: true }].concat(this.budgetTypeOptions);
      }
    });
  }


  getFundSubCategoryList(typeid:any) {
    let model = new ScreenResponseModel();
    model.Id = typeid;
    model.AppId = this.appid;
    model.RowId = null;
    this.summaryService.getBudgetSubTypeList(model).subscribe((result) => {
      if (result != null) {
        this.budgetSubTypeOptions = result;
        this.budgetSubTypeOptions = [{ label: "Select", value: null, checked: true }].concat(this.budgetSubTypeOptions);
      }
    });
  }

  getSelectedValue(value: any): void {
    this.getFundSubCategoryList(value);
  }

  getLatestSymbol()
  {
    if (this.granttype == 1)
    {
      this.userService.getGrantCMECurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 2)
    {
      this.userService.getGrantSponsorCurrencySymbol(this.appid).subscribe(x=>{
        this.grantcurrencycode=x["Data"];
        if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
         this.grantcurrencycode = "$";
      });
    }
    else if (this.granttype == 3)
    {
      // this.userService.getGrantCharitableCurrencySymbol(this.appid).subscribe(x=>{
      //   this.grantcurrencycode=x["Data"];
      //   if (this.grantcurrencycode == null || this.grantcurrencycode == undefined || this.grantcurrencycode == "")
      //    this.grantcurrencycode = "$";
      // });
    }
  }

  GetScreenConfigControls(screenCode: string) {
    this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, this.ApplicationID,(ScreenData) => {
      this.SCREEN_MODEL = ScreenData;
      this.ScreenName = this.SCREEN_MODEL?.NAME;
      this.staticformFieldsLstest = ScreenData["SCREEN_CONTROL"];
    });
  }


  GetEditData(): void {
    this.summaryService.getBudget(this.Content.content.id).subscribe(summary => {
      this.budgetType = summary["BUGET_TYPE_ID"];
      this.budgetSubType = summary["BUDGET_SUB_TYPE_ID"];

      this.allocateBudgetForm.patchValue({
        ID: summary["ID"],
        APPLICATION_ID: summary["APPLICATION_ID"],
        BUGET_TYPE_ID: summary["BUGET_TYPE_ID"],
        BUDGET_SUB_TYPE_ID: summary["BUDGET_SUB_TYPE_ID"],
        TOTAL_FEE: summary["TOTAL_FEE"],
        REQUESTED_AMOUNT: summary["REQUESTED_AMOUNT"],
        NOTES: summary["NOTES"],
        ALLOCATION_AMOUNT: summary["ALLOCATION_AMOUNT"],
        ALLOCATION_DATE: summary["ALLOCATION_DATE"],
        ALLOCATION_NOTES: summary["ALLOCATION_NOTES"]
      });

      if (summary["ALLOCATION_DATE"] != null && summary["ALLOCATION_DATE"] != "") {
        // this.allocateBudgetForm.controls["ALLOCATION_DATE"].setValue(formd2);
        let formd2 = this.commonService.getdisplayedDate(this.allocateBudgetForm.controls["ALLOCATION_DATE"].value);
        this.allocateBudgetForm.controls["ALLOCATION_DATE"].setValue(formd2);
      }
      this.totalfee = summary["TOTAL_FEE"];
      this.requestamount = summary["REQUESTED_AMOUNT"];
      this.budgetNotes=summary["NOTES"];
      if(summary["STATUS"] > 1){
        this.grantcurrencycode = summary["CURRENCY_SYMBOL"];
      }
      this.StatusStr = summary["StatuStr"];

      if ( summary["APPROVED_DATE"] != null &&  summary["APPROVED_DATE"] != "") {
        let formd2 = new Date(summary["APPROVED_DATE"]);
        this.approvedDate = formd2;
      }

      this.minDate = this.approvedDate;

      if (this.extendedForm != null && this.extendedForm != undefined) {
        this.extendedForm.rowid = summary["ID"];
        this.extendedForm.getResponse();
      }
      if(this.grantcurrencycode==null || this.grantcurrencycode==undefined || this.grantcurrencycode=="")
      {
        this.getLatestSymbol()
      }
      
    });


  }

  SaveBudget() {

    if (this.validateControls()) {
      let formDate = this.allocateBudgetForm.value;

      formDate["APPLICATION_ID"] = this.appid;
      formDate["TOTAL_FEE"] = parseInt(this.totalfee);
      formDate["REQUESTED_AMOUNT"] = parseInt(this.requestamount);
      formDate["ALLOCATION_AMOUNT"] = parseInt(formDate["ALLOCATION_AMOUNT"]);
      formDate["STATUS"] = 11;
      formDate["BUGET_TYPE_ID"] = this.budgetType;
      formDate["BUDGET_SUB_TYPE_ID"] = this.budgetSubType;
      formDate["NOTES"] = this.budgetNotes;

      if (formDate["ALLOCATION_DATE"] != null && formDate["ALLOCATION_DATE"] != "") {
        formDate["ALLOCATION_DATE"] = new Date(formDate["ALLOCATION_DATE"]);
      }

      formDate["AllocationDateO"] = this.GetAllocateDate();

      this.summaryService.Update('api/gmbudget/update', formDate).subscribe(summary => {
        this.extendedForm.saveControls(this.Content.content.id).subscribe(result => {
          if (summary.Status == 0) {
            this.commonService.SuccessBanner('Budget request details updated successfully');
            this.modalRef.close();
            this.GetEditData();
          } else {
            this.commonService.ValidationBanner(summary.Message);
          }
        });
      });
    }
  }

  validateControls(){
    let formDate = this.allocateBudgetForm.value;
    let isValid = true;
    let message = "";

    
    if (this.staticformFields?.ALLOCATION_AMOUNT.IS_Display && this.staticformFields?.ALLOCATION_AMOUNT.IS_MANDATORY) {
      if (formDate.ALLOCATION_AMOUNT === null || formDate.ALLOCATION_AMOUNT === "" || formDate.ALLOCATION_AMOUNT === undefined) {
        $("#ALLOCATION_AMOUNT").addClass("ng-touched ng-invalid validate-error");
        $("#ALLOCATION_AMOUNT").removeClass("ng-untouched ng-valid");
        message += `Please enter ${this.staticformFields?.ALLOCATION_AMOUNT?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        //$("#TOTAL_FEE").addClass("ng-untouched ng-valid");
        //$("#TOTAL_FEE").removeClass("ng-touched ng-invalid validate-error");
        if (!isNaN(formDate.ALLOCATION_AMOUNT)) {
          $("#ALLOCATION_AMOUNT").addClass("ng-untouched ng-valid");
          $("#ALLOCATION_AMOUNT").removeClass("ng-touched ng-invalid validate-error");
        }
        else {
          $("#ALLOCATION_AMOUNT").addClass("ng-touched ng-invalid validate-error");
          $("#ALLOCATION_AMOUNT").removeClass("ng-untouched ng-valid");
          message += "Allocation Amount field will allow only numeric values<br/>";
          isValid = false;
        }
      }
    }

    if (formDate["ALLOCATION_AMOUNT"] != null && parseInt(formDate["ALLOCATION_AMOUNT"]) > parseInt(this.requestamount) ) {
      $("#ALLOCATION_DATE").addClass("ng-touched ng-invalid validate-error");
      $("#ALLOCATION_DATE").removeClass("ng-untouched ng-valid");
      message += "The allocation amount cannot be greater than requested amount<br/>";
      isValid = false;
    } else {
      $("#ALLOCATION_DATE").addClass("ng-untouched ng-valid");
      $("#ALLOCATION_DATE").removeClass("ng-touched ng-invalid validate-error");
    }

    if (this.staticformFields?.ALLOCATION_DATE.IS_Display && this.staticformFields?.ALLOCATION_DATE.IS_MANDATORY) {
      if (formDate.ALLOCATION_DATE === null || formDate.ALLOCATION_DATE === "" || formDate.ALLOCATION_DATE === undefined) {
        $("#ALLOCATION_DATE").addClass("ng-touched ng-invalid validate-error");
        $("#ALLOCATION_DATE").removeClass("ng-untouched ng-valid");
        message +=  `Please select ${this.staticformFields?.ALLOCATION_DATE?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#ALLOCATION_DATE").addClass("ng-untouched ng-valid");
        $("#ALLOCATION_DATE").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (this.staticformFields?.ALLOCATION_NOTES.IS_Display && this.staticformFields?.ALLOCATION_NOTES.IS_MANDATORY) {
      if (formDate.ALLOCATION_NOTES === null || formDate.ALLOCATION_NOTES === "" || formDate.ALLOCATION_NOTES === undefined) {
        $("#ALLOCATION_NOTES").addClass("ng-touched ng-invalid validate-error");
        $("#ALLOCATION_NOTES").removeClass("ng-untouched ng-valid");
        message +=  `Please enter ${this.staticformFields?.ALLOCATION_NOTES?.LABEL_NAME}<br/>`;
        isValid = false;
      } else {
        $("#ALLOCATION_NOTES").addClass("ng-untouched ng-valid");
        $("#ALLOCATION_NOTES").removeClass("ng-touched ng-invalid validate-error");
      }
    }

    if (!isValid) {
      this.commonService.ValidationBanner(message);
     // this.modalService.show(MessageBoxComponent, { data: { heading: 'Validations', content: { heading: '', description: message } } });
      return isValid;
    }

    return isValid;
  }

  onAllocateDate(event) {
    this.IsAllocatedDateModified = true;
    this.ALLOCATE_DATE = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 23,
      Minutes: 59,
      Seconds: 59,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.IsAllocatedDateModified,
    }
  }

  GetAllocateDate(): DateObject {
    const formModel = this.allocateBudgetForm.getRawValue();
    const date = new Date(formModel.ALLOCATION_DATE);
     if (this.ComparingDates(this.CurrentDate, date) || this.ALLOCATE_DATE == null || this.ALLOCATE_DATE == undefined) {
       this.ALLOCATE_DATE = {
         Day: date.getDate(),
         Month: (date.getMonth() + 1),
         Year: date.getFullYear(),
         Hours: 23,
         Minutes: 59,
         Seconds: 59,
         IsEndDate: false,
         HasValue: true,
         IsDateModified: false
       }
     }
     return this.ALLOCATE_DATE;
  }

  ComparingDates(oldDate: any, newDate: any) {
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }
}
